module.exports = __webpack_public_path__ + "static/appDemo02-7b18d09bf340f5af710f781201b4f9d9.png";